
import { getSettings } from '../../../HttpRequests/settings'
import { setSettings } from '../State/settings'
import { setFetching } from '../State/fetching'
import { setPagination } from '../State/pagination'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const { searchTerm, filters, sorting, pagination } = getState().screens.Settings
    
  const params = {}

  if (searchTerm) params.search = searchTerm

  if (filters.type !== 'All') {
    params['filter[type]'] = filters.type
  }

  // Only set group filter if it has a value
  if (filters.group) {
    params['filter[group]'] = filters.group
  }

  //params.sort = sorting.columnKey ? (sorting.descending ? '-' : '') + sorting.columnKey : 'full_name'

  params['page[number]'] = 1;//pagination.pageNumber
  params['page[size]'] = 1000;//pagination.pageSize

  dispatch(setFetching(true))

  try {
    console.log('Fetching settings with params:', params);

    const response = await getSettings({ params })
    console.log('API response:', response);
    
    // Ensure we have valid data before dispatching
    if (response && response.data && Array.isArray(response.data.rows)) {
      console.log('Valid data rows:', response.data.rows);
      dispatch(setSettings(response.data.rows))
    } else {
      console.log('No valid data rows, dispatching empty array');
      // If no valid data, dispatch an empty array to avoid undefined
      dispatch(setSettings([]))
    }

    // Only update pagination if we have valid pagination data
    if (response && response.data && response.data.pagination) {
      dispatch(setPagination({
        pageNumber: response.data.pagination.current_page,
        pageSize: response.data.pagination.per_page,
        total: response.data.pagination.total,
      }))
    }

    dispatch(setFetching(false))

  } catch (error) {

    handleException(error)

  }

}
